import { useEffect } from 'react';

export default function Modal({ onClose, children }) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-body" role="dialog" aria-modal="true">{children}</div>
    </div>
  );
}

export function Picker({ options, value, onChange, kind = 'color' }) {
  return (
    <div className="picker">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={`pick ${kind === 'color' ? 'color' : ''} ${option === value ? 'on' : ''}`}
          style={kind === 'color' ? { background: option } : undefined}
          onClick={() => onChange(option)}
          aria-label={option}
          aria-pressed={option === value}
        >
          {kind === 'color' ? '' : option}
        </button>
      ))}
    </div>
  );
}
